import { createAsyncThunk } from "@reduxjs/toolkit";

import {
    getCategoryList as getCategoryListApi,
    addCategoryList as addCategoryListApi,
    updateCategoryList as updateCategoryListApi,
    deleteCategoryList as deleteCategoryListApi
} from "../../helpers/helper";
import { toast } from "react-toastify";

export const getCategoryList = createAsyncThunk("Category/getCategoryList", async () => {
    try {
        const response = await getCategoryListApi();
        return response;
    } catch (error) {
        return error;
    }
});
export const addCategoryList = createAsyncThunk("Category/addCategoryList", async (category: any) => {
    try {
        const response = addCategoryListApi(category);
        const data = await response;
        toast.success("Category Added Successfully", { autoClose: 2000 });
        return data;
    } catch (error) {
        toast.error("Category Added Failed", { autoClose: 2000 });
        return error;
    }
});

export const updateCategoryList = createAsyncThunk("Category/update", async (dataArr: any) => {
    try {
        const response = updateCategoryListApi(dataArr);
        const data = await response;
        toast.success("Category Updated Successfully", { autoClose: 2000 });
        return data;
    } catch (error) {
        toast.error("Category Updated Failed", { autoClose: 2000 });
        return error;
    }
});

export const deleteCategoryList = createAsyncThunk("Category/deleteCategoryList", async (categoryId: any) => {
    try {
        const response = deleteCategoryListApi(categoryId);
        console.log(response);
        toast.success("Category Deleted Successfully", { autoClose: 2000 });
        return categoryId;
    } catch (error) {
        toast.error("Category Deleted Failed", { autoClose: 2000 });
        return error;
    }
})
